import { BaseFetch } from "../main-model";
export default class ExportPP6Model extends BaseFetch {
  getExportPP6By = (data) =>
    this.authFetch({
      url: "export-pp6/getExportPP6By",
      method: "POST",
      body: JSON.stringify(data),
    });
    getExportPP6SubjectBy = (data) =>
    this.authFetch({
      url: "export-pp6/getExportPP6SubjectBy",
      method: "POST",
      body: JSON.stringify(data),
    });
    getExportPP6ClassRoomSubjectBy = (data) =>
    this.authFetch({
      url: "export-pp6/getExportPP6ClassRoomSubjectBy",
      method: "POST",
      body: JSON.stringify(data),
    });  
    getExportPP6PeriodType2 = (data) =>
    this.authFetch({
      url: "export-pp6/getExportPP6PeriodType2",
      method: "POST",
      body: JSON.stringify(data),
    });
}
